"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var peopleIdentity_1 = require("owa-service/lib/factory/peopleIdentity");
/**
 * Maps the recipient well from the rule edit page to PeopleIdentity type
 * @return the PeopleIdentity list with the corresponding recipients as items
 */
function mapReadWriteRecipientWellViewStateToPeopleIdentity(recipientWell) {
    // map conditional clauses
    var peopleIdentities = [];
    for (var _i = 0, _a = recipientWell.recipients; _i < _a.length; _i++) {
        var recipient = _a[_i];
        var mailbox = recipient.persona.EmailAddress;
        var identity = peopleIdentity_1.default({
            DisplayName: mailbox.Name,
            SmtpAddress: mailbox.EmailAddress,
            RoutingType: mailbox.RoutingType,
        });
        peopleIdentities.push(identity);
    }
    return peopleIdentities.length > 0 ? peopleIdentities : null;
}
exports.default = mapReadWriteRecipientWellViewStateToPeopleIdentity;
//# sourceMappingURL=mapReadWriteRecipientWellViewStateToPeopleIdentity.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/mapReadWriteRecipientWellViewStateToPeopleIdentity.js
// module id = 5231
// module chunks = 2